// Deterministic avatar color + initials

function hashStr(s) {
  let h = 0;
  const str = s || '?';
  for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

const AVATAR_BG = [
  'var(--av-1)', 'var(--av-2)', 'var(--av-3)', 'var(--av-4)',
  'var(--av-5)', 'var(--av-6)', 'var(--av-7)', 'var(--av-8)',
];

// Concrete hex versions for PDF (where CSS vars don't work)
const AVATAR_BG_HEX = [
  '#e88a3a', '#3a7bd5', '#9a6cd9', '#2bbf85',
  '#e35aa6', '#2ab8b8', '#d9a824', '#6b6545',
];

export function avatarColor(name) {
  return AVATAR_BG[hashStr(name) % AVATAR_BG.length];
}

export function avatarColorHex(name) {
  return AVATAR_BG_HEX[hashStr(name) % AVATAR_BG_HEX.length];
}

export function initials(name) {
  if (!name) return '?';
  const parts = String(name).replace(/[^A-Za-zÀ-žÀ-ž0-9 ]/g, ' ').split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
